// src/bootstrap/redux/selectors/SiteMetadataSelectors.ts
import { Selector } from 'reselect';

import { ISiteMetadata } from '~src/siteManagement/serverApi/types/ISiteMetadata';

import { AppState } from '../state/AppState';

const selectSiteMetadataRoot: Selector<AppState, ISiteMetadata | null> =
  state => state.siteMetadata && state.siteMetadata.info;

export namespace SiteMetadataSelectors {
  export const metadata: Selector<AppState, ISiteMetadata | null> = selectSiteMetadataRoot;

  export const siteTypeName: Selector<AppState, string | undefined> =
    state => selectSiteMetadataRoot(state)?.siteTypeName;

  export const siteUuid: Selector<AppState, string | undefined> =
    state => selectSiteMetadataRoot(state)?.siteUuid;

  export const isSiteExpiring: Selector<AppState, boolean> =
    state => !!selectSiteMetadataRoot(state)?.isSiteExpiring;

  export const siteExpiringDays: Selector<AppState, number> =
    state => selectSiteMetadataRoot(state)?.siteExpiringDays ?? 0;

  export const isActivityLogEnabled: Selector<AppState, boolean> =
    state => !!selectSiteMetadataRoot(state)?.isActivityLogEnabled;

  export const org62RecordId: Selector<AppState, string | undefined> =
    state => selectSiteMetadataRoot(state)?.org62RecordId;

  export const isLinkSite: Selector<AppState, boolean> =
    state => !!selectSiteMetadataRoot(state)?.isLinkSite;

  export const isAdminInsightsEnabled: Selector<AppState, boolean> =
    state => !!selectSiteMetadataRoot(state)?.isAdminInsightsEnabled;

  export const isBuyLicensesEnabled: Selector<AppState, boolean> =
    state => !!selectSiteMetadataRoot(state)?.isBuyLicensesEnabled;

  export const isSubscribeNowEnabled: Selector<AppState, boolean> =
    state => !!selectSiteMetadataRoot(state)?.isSubscribeNowEnabled;

  export const isInlineBannerEnabled: Selector<AppState, boolean> =
    state => !!selectSiteMetadataRoot(state)?.isInlineBannerEnabled;

  export const isTrial: Selector<AppState, boolean> =
    state => !!selectSiteMetadataRoot(state)?.isTrial;

  export const isBeta: Selector<AppState, boolean> =
    state => !!selectSiteMetadataRoot(state)?.isBeta;

  export const expiration: Selector<AppState, string | undefined> =
    state => selectSiteMetadataRoot(state)?.expiration;
}